import * as React from 'react';
import { CalendarViewToggleProps } from '../../components/calendar-view-toggle';
import { CalendarViewMode } from '../../classes/calendar';


const CalendarModeToggleView: React.StatelessComponent<CalendarViewToggleProps> = props => {
    return (
        <div className="ace-cal-toggles ace-cal-subnav-item">
            <button className="ace-cal-toggles-btn" type="button" disabled={props.calendarMode === CalendarViewMode.GRID} onClick={() => props.setToGrid()}>
                <svg className="ace-cal-toggles-icon ace-cal-toggles-icon-grid" aria-hidden="true" dangerouslySetInnerHTML={{ __html: '<use xlink:href="#icon-cal-grid" />' }} />
                <span>
                    {props.text.setToGridViewButtonText}
                </span>
            </button>
            <button className="ace-cal-toggles-btn" type="button" disabled={props.calendarMode === CalendarViewMode.LIST} onClick={() => props.setToList()}>
                <svg className="ace-cal-toggles-icon" aria-hidden="true" dangerouslySetInnerHTML={{ __html: '<use xlink:href="#icon-cal-list" />' }} /> 
                <span>
                    {props.text.setToListViewButtonText}
                </span>
            </button >
        </div>
    );
}

export default CalendarModeToggleView;